// Browser-la save aagum (server sync backend phase-la). Keys versioned.
const FIELDS_KEY = 'vbot_lead_fields_v1';
const TYPES_KEY = 'vbot_lead_types_v1';
const VALUES_KEY = 'vbot_lead_custom_values_v1';

export const DEFAULT_FIELDS = [
  { id: 'name', label: 'Name', type: 'text', required: true, system: true },
  { id: 'phone', label: 'Phone', type: 'text', required: true, system: true },
  { id: 'source', label: 'Source', type: 'dropdown', required: false, system: true },
  { id: 'product_tag', label: 'Product', type: 'text', required: false, system: true },
  { id: 'status', label: 'Status', type: 'dropdown', required: true, system: true },
  { id: 'assigned_agent_id', label: 'Assigned Agent', type: 'dropdown', required: false, system: true },
  { id: 'notes', label: 'Notes', type: 'text', required: false, system: true },
];

const read = (k, fb) => { try { const v = JSON.parse(localStorage.getItem(k)); return v == null ? fb : v; } catch (e) { return fb; } };
const write = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };

export function getFields() {
  const saved = read(FIELDS_KEY, null);
  if (!Array.isArray(saved)) return DEFAULT_FIELDS.map(f => ({ ...f }));
  const ids = new Set(saved.map(f => f.id));
  return [...saved, ...DEFAULT_FIELDS.filter(f => !ids.has(f.id)).map(f => ({ ...f }))];
}
export const setFields = (f) => write(FIELDS_KEY, f);
export const getCustomFields = () => getFields().filter(f => !f.system);

export const getLeadTypes = () => read(TYPES_KEY, []);
export const setLeadTypes = (t) => write(TYPES_KEY, t);

// per-lead custom values: { [leadId]: { fieldId: value, __lead_type: 'Retail' } }
export const getCustomValues = (leadId) => (read(VALUES_KEY, {})[leadId]) || {};
export function setCustomValues(leadId, vals) {
  const all = read(VALUES_KEY, {});
  all[leadId] = vals;
  write(VALUES_KEY, all);
}
